import qs from 'qs';
import { api } from 'src/api/api';
import {
  FiagroAssetRaw,
  FiagroLiabilityRaw,
  FiagroLiabilitySubclassesData,
  FiagroResumeData,
  FiagroTotalizers,
  ServiceProviderData,
} from 'src/types/operations/fiagro';

export const getFiagroTotalizers = async () => {
  const { data } = await api.get<FiagroTotalizers[]>(
    '/meta-fiagro-operations/totalizers',
  );
  return data;
};

export const getOperationFIAGROServiceProviderTabData = async (
  hash: string,
) => {
  const { data } = await api.get<ServiceProviderData>(
    `/meta-fiagro-perfil-dos-fundos/${hash}/service-providers`,
  );
  return data;
};

export const getFiagroResumeData = async (hash: string) => {
  const { data } = await api.get<FiagroResumeData[]>(
    `/meta-fiagro-perfil-dos-fundos/${hash}/resume-fund-data`,
  );
  return data;
};

export const getFiagroAssetData = async (
  hash: string,
  pageSize = 1000,
  startDate?: string,
) => {
  const query = qs.stringify(
    {
      pagination: { pageSize },
      sort: ['dataReferencia:desc'],
      ...(startDate && { filters: { dataReferencia: { $gte: startDate } } }),
    },
    { encodeValuesOnly: true },
  );
  const { data } = await api.get<{ data: FiagroAssetRaw[] }>(
    `/meta-fiagro-informacao-dos-fundos-raws/${hash}?${query}`,
  );
  return data.data;
};

export const getFiagroLiabilityData = async (
  hash: string,
  pageSize = 1000,
  startDate?: string,
) => {
  const query = qs.stringify(
    {
      pagination: { pageSize },
      sort: ['dataReferencia:desc'],
      ...(startDate && { filters: { dataReferencia: { $gte: startDate } } }),
    },
    { encodeValuesOnly: true },
  );
  const { data } = await api.get<{ data: FiagroLiabilityRaw[] }>(
    `/meta-fiagro-informacao-dos-fundos-raws/${hash}?${query}`,
  );
  return data.data;
};

export const getFiagroLiabilitySubclassesData = async (
  hash: string,
  pageSize = 1000,
  startDate?: string,
) => {
  const query = qs.stringify(
    {
      pagination: { pageSize },
      sort: ['dataReferencia:desc'],
      ...(startDate && { filters: { dataReferencia: { $gte: startDate } } }),
    },
    { encodeValuesOnly: true },
  );

  const { data } = await api.get<{ data: FiagroLiabilitySubclassesData[] }>(
    `/meta-fiagro-informacao-dos-fundos-subclasses/${hash}?${query}`,
  );
  return data.data;
};

export const generateCsv = async (filters?: Record<string, any>) => {
  const query = qs.stringify(
    {
      ...(filters ? { filters } : {}),
    },
    { encodeValuesOnly: true },
  );
  const { data } = await api.get(
    `/meta-fiagro-operations/generate-csv?${query}`,
  );
  return data;
};

export const getCsvStatus = async (jobId: string) => {
  const { data } = await api.get(`/meta-fiagro-operations/csv-status/${jobId}`);
  return data;
};

export const downloadCsv = async (jobId: string) => {
  const response = await api.get(
    `/meta-fiagro-operations/download-csv/${jobId}`,
    {
      responseType: 'blob',
    },
  );
  return response;
};
